import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { LoyaltyApi } from "../../services";
import { BrowserStorage, User } from "../../utils";

const user = new User(new BrowserStorage());

type LoyaltyData =
  | {
      status: "hidden";
    }
  | {
      status: "visible";
      earnedPoints: number;
    };

export const useLoyaltyData = (orderId: string, isRestricted: boolean): LoyaltyData => {
  const loyaltyApi = LoyaltyApi.init();
  const { ciam_token, uuid } = user.getUser();

  const getLoyaltyStatusQuery = useQuery({
    queryKey: [QUERY_KEYS.loyaltyStatus],
    queryFn: () => loyaltyApi.getStatus(),
  });

  const getEarnedPointsQuery = useQuery({
    queryKey: [QUERY_KEYS.earnedPoints, orderId, ciam_token, uuid],
    queryFn: () => loyaltyApi.getEarnedPoints(orderId, ciam_token, uuid),
  });

  if (!getLoyaltyStatusQuery.data || !getEarnedPointsQuery.data || isRestricted) {
    return {
      status: "hidden",
    };
  }

  return {
    status: "visible",
    earnedPoints: getEarnedPointsQuery.data,
  };
};
